module.exports = __webpack_public_path__ + "img/78.f473ff07.jpg";